import {
  useEventingContext
} from "@/context/eventing"
import mergeOperations from "@/util/shallowMerge"
import {
  useLazyQuery, useQuery
} from "@apollo/client"
import {
  useRouter
} from "next/navigation"
import {
  useCallback, useEffect, useMemo
} from "react"
import DEFAULT_OPERATIONS from "./categoryContent.gql"

export const useCategoryContent = (props) => {
  const {
    categoryId,
    data,
    pageSize = 6,
    aggregations,
    categories,
    sortFields,
  } = props

  const router = useRouter()

  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    getCategoryContentQuery,
    getProductFiltersByCategoryQuery,
    getCategoryAvailableSortMethodsQuery,
    getCurrencyQuery,
  } = operations

  const placeholderItems = Array.from({
    length: pageSize 
  }).fill(null)

  // const { data: currencyData } = useQuery(getCurrencyQuery, {
  //     fetchPolicy: 'cache-and-network',
  //     nextFetchPolicy: 'cache-first',
  // })

  // 少调用一个接口优化速度
  const currencyData = {
    "currency": {
      "default_display_currency_code": "USD",
      "available_currency_codes": [
        "USD"
      ],
      "__typename": "Currency"
    }
  }

  // 貌似一直是 undefined
  const currentCurrencyCode = useMemo(() => {
    if (currencyData) {
      return currencyData.currency.current_currency_code
    }
  }, [currencyData])

  const [getFilters, {
    data: filterData 
  }] = useLazyQuery(
    getProductFiltersByCategoryQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  )

  const [getSortMethods, {
    data: sortData 
  }] = useLazyQuery(
    getCategoryAvailableSortMethodsQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  )

  const {
    data: categoryData, 
    loading: categoryLoading,
    fetchMore
  } = useQuery(
    getCategoryContentQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      skip: !categoryId,
      variables: {
        id: categoryId,
      },
    }
  )

  const [, {
    dispatch 
  }] = useEventingContext()

  useEffect(() => {
    if (categoryId) {
      getFilters({
        variables: {
          categoryIdFilter: {
            eq: categoryId,
          },
        },
      })
    }
  }, [categoryId, getFilters])

  useEffect(() => {
    if (categoryId) {
      getSortMethods({
        variables: {
          categoryIdFilter: {
            in: categoryId,
          },
        },
      })
    }
  }, [categoryId, getSortMethods])

  const filters = filterData?.products?.aggregations || null
  const items = data?.products?.items || placeholderItems
  const totalPagesFromData = data?.products?.page_info?.total_pages || null

  const totalCount = data?.products?.total_count || null

  const categoryName =
        categoryData && categoryData.categories.items.length
          ? categoryData.categories.items[0].name
          : null

  const originalCategoryDescription =
        categoryData && categoryData.categories.items.length
          ? categoryData.categories.items[0].description
          : null

  const ads = data?.categories?.items[0]?.adv

  const categoryDescription =
        originalCategoryDescription &&
            originalCategoryDescription.indexOf('<div data-content-type="html" data-appearance="default" data-element="main">') > -1
          ? originalCategoryDescription
            .replaceAll(
              '<div data-content-type="html" data-appearance="default" data-element="main">',
              ""
            )
            .replaceAll("</div>", "")
            .replaceAll("&gt;", ">")
            .replaceAll("&lt;", "<")
            .replaceAll("&amp;", "&")
          : originalCategoryDescription

  const availableSortMethods = sortData?.products?.sort_fields
    ? sortData.products.sort_fields.options
    : null

  const categoryImage =
        categoryData && categoryData.categories.items.length
          ? categoryData.categories.items[0].category_image
          : null

  const onClearFilters = useCallback(() => {
    if (categoryData?.categories?.items) {
      router.push(`/${categoryData.categories.items[0].url_key}`)
    }
  }, [categoryData, router])

  const onSearchFormSubmit = useCallback(
    (formState) => {
      const {
        search_key 
      } = formState.values

      router.push(`/search.html?query=${search_key}`)
    },
    [router]
  )

  useEffect(() => {
    if (!categoryLoading && categoryData?.categories?.items?.length > 0) {
      dispatch({
        type: "CATEGORY_PAGE_VIEW",
        payload: {
          id: categoryData?.categories?.items?.[0]?.uid,
          name: categoryData?.categories?.items?.[0]?.name,
          url_key: categoryData?.categories?.items?.[0]?.url_key,
          url_path: categoryData?.categories?.items?.[0]?.url_path,
        },
      })
    }
  }, [categoryData, dispatch, categoryLoading])

  return {
    availableSortMethods,
    categoryName,
    fetchMore,
    categoryIntId:
            categoryData && categoryData.categories.items.length
              ? categoryData.categories.items[0].id
              : null,
    categoryUrlKey:
            categoryData && categoryData.categories.items.length
              ? categoryData.categories.items[0].url_key
              : null,
    categoryDescription,
    categoryImage,
    filters,
    items,
    totalCount,
    totalPagesFromData,
    ads,
    onClearFilters,
    onSearchFormSubmit,
    currentCurrencyCode,
  }
}
